import { render, staticRenderFns } from "./ImportStudentModal.vue?vue&type=template&id=f509ea7a"
import script from "./ImportStudentModal.vue?vue&type=script&lang=js"
export * from "./ImportStudentModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports